class PdpV3Gallery extends HTMLElement {
  #abortController = new AbortController();
  #resizeObserver;

  connectedCallback() {
    this.#abortController.abort();
    this.#resizeObserver?.disconnect();
    this.#abortController = new AbortController();

    const scroller = this.querySelector('[data-pdp-v3-gallery-scroller]');
    const previous = this.querySelector('[data-pdp-v3-gallery-previous]');
    const next = this.querySelector('[data-pdp-v3-gallery-next]');
    if (!scroller || !previous || !next) return;

    const updateControls = () => {
      previous.disabled = scroller.scrollLeft <= 1;
      next.disabled = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 1;
    };
    const scroll = (direction) => {
      const item = scroller.firstElementChild;
      if (!item) return;
      const gap = Number.parseFloat(getComputedStyle(scroller).columnGap) || 0;
      let step = item.getBoundingClientRect().width + gap;
      if (this.dataset.pdpV3GalleryStep === 'page') {
        step *= Math.max(1, Math.round((scroller.clientWidth + gap) / step));
      }
      scroller.scrollBy({
        left: direction * step,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    };

    previous.addEventListener('click', () => scroll(-1), { signal: this.#abortController.signal });
    next.addEventListener('click', () => scroll(1), { signal: this.#abortController.signal });
    scroller.addEventListener('scroll', updateControls, { passive: true, signal: this.#abortController.signal });
    window.addEventListener('resize', updateControls, { signal: this.#abortController.signal });
    this.#resizeObserver = new ResizeObserver(updateControls);
    this.#resizeObserver.observe(scroller);
    if (scroller.firstElementChild) this.#resizeObserver.observe(scroller.firstElementChild);
    updateControls();
  }

  disconnectedCallback() {
    this.#abortController.abort();
    this.#resizeObserver?.disconnect();
  }
}

if (!customElements.get('pdp-v3-gallery')) {
  customElements.define('pdp-v3-gallery', PdpV3Gallery);
}
